import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { APP_CONFIG_OFERTAS, IAppOfertas } from 'src/app/app.config/app.config-ofertas';
import { Curso } from 'src/app/interfaces/interface-bakend/cursos/curso.interface';
import { ActividadDAdjunto } from 'src/app/interfaces/interface-bakend/ofertas-laborales/actividad-adjuntos.interface';
import { Actividad } from 'src/app/interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { Catalogo } from 'src/app/interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { PaisDisponible } from 'src/app/interfaces/interface-bakend/shared/paises/pais-disponible/pais-disponible.interface';
import { CursosService } from 'src/app/services/cursos/cursos.service';
import { ActividadesService } from 'src/app/services/ofertas-laborales/actividades.service';
import { CatalogoService } from 'src/app/services/shared/catalogo.service';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { MediaService } from 'src/app/services/shared/media.service';
import { PaisesService } from 'src/app/services/shared/paises.service';
import { ValidadoresService } from 'src/app/services/shared/validadores.service';
import Swal from 'sweetalert2';
import { DocumentosEstadosSolicitar } from 'src/app/interfaces/interface-bakend/ofertas-laborales/actividad.interface';

// config Beneficios
import { AppBeneficios } from 'src/app/app.config/app.config-beneficios';
import { TipoActividad } from 'src/app/app.config/app.config-beneficios';
import { frecuenciaBeneficios } from 'src/app/app.config/app.config-beneficios';

// import Beneficios
import { MatSelectChange } from '@angular/material/select';
import { map } from 'rxjs/operators';

// service Beneficios
import { TipoActividadService } from 'src/app/services/tipo-actividad.service';
import { readImagePreview } from '@shared/utils/image-upload.util';

@Component({
  selector: 'app-modificacion-noticia',
  templateUrl: './modificacion-noticia.component.html',
  styleUrls: ['./modificacion-noticia.component.scss']
})
export class ModificacionNoticiaComponent implements OnInit {

  currentDate = new Date();
  form: FormGroup;
  actividad: any;
  adjuntos: ActividadDAdjunto[];
  cursosModulos: Curso[];
  paisesDisponibles: PaisDisponible[];
  flagLoaded = false;
  flagLoadedAdjuntos = false;
  tipoPuestos: Catalogo[] = [];
  modalidades: Catalogo[] = [];
  areas: Catalogo[] = [];
  // Upload
  flagSelectFile = false;
  selectedFile: any;
  value = 0;
  cargandoArchivo = false;
  subscriptionAvance: Subscription;

  condition = false;
  fileName = 'No file selected';
  file: File;

  /* ripple */
  centered = false;
  disabled = false;
  unbounded = false;

  /* img portada */
  fileAttr = 'Choose File';


  radius: number;
  color: string;


  // arreglo de documentos que solicita 
  documentosEstadosSolicitar: DocumentosEstadosSolicitar[] = [];

  imageUrl: string | ArrayBuffer =
    './assets/img/uploadImg.png';
  esHeic = false;

  circuitos: any[] = [];

  flagProcesando = false;

  //especifico Beneficios

  beneficios = AppBeneficios.entidades;
  frecuenciaB = frecuenciaBeneficios.frecuencia;
  selectedEntidades: { valor: number, descripcion: string }[] = [];
  tipoActividades: { idTipoActividad: string, denominacionTipoActividad: string }[] = [];
  selectedIdTipoActividad: string | null = null; // Para almacenar el id seleccionado

  constructor(private fb: FormBuilder,
    private router: Router,
    private actividadesService: ActividadesService,
    private paisesService: PaisesService,
    private mediaService: MediaService,
    private guiMsjService: GuiMsjService,
    private catalogoService: CatalogoService,
    private validadores: ValidadoresService,
    private cursosService: CursosService,
    @Inject(APP_CONFIG_OFERTAS) private iAppOfertas: IAppOfertas,
    private tipoActividadService: TipoActividadService,
  ) {
    this.getActividad();
    this.getAdjuntosAll();
    this.getCursosModulo();
    this.getPaisesDisponibles();
    this.getTipoPuestos();
    this.getModalidades();
    this.getAreas();
    this.getCircuitos();
  }

  ngOnInit(): void {
    this.getEstadoVariables();
    this.createForm();
    this.form.valueChanges.subscribe(val => {
      console.log('Valores actuales del formulario:', val);
    });
    this.form.get('pais').setValue('60be8f071c40f401f361a61d');
    // this.tipoActividadService.logTipoActividades(); // log de las actividadTipo (categorias)
    this.obtenerTipoActividades();
  }

  get nombreNoValido() {
    return this.form.get('nombre').invalid && this.form.get('nombre').touched;
  }

  get sueldoNoValido() {
    return this.form.get('sueldo').invalid && this.form.get('sueldo').touched;
  }

  get costoAdministrativoNoValido() {
    return this.form.get('costoAdministrativo').invalid && this.form.get('costoAdministrativo').touched;
  }

  get costoPostAprobacionNoValido() {
    return this.form.get('costoPostAprobacion').invalid && this.form.get('costoPostAprobacion').touched;
  }

  get importanteNoValido() {
    return this.form.get('importante').invalid && this.form.get('importante').touched;
  }

  get documentacionNoValida() {
    return this.form.get('documentacionRequerida').invalid && this.form.get('documentacionRequerida').touched;
  }

  get paisNoValido() {
    return this.form.get('nombre').invalid && this.form.get('pais').touched;
  }

  get adjuntoNoValido() {
    return this.form.get('adjuntos').invalid && this.form.get('adjuntos').touched;
  }
  get documentosEstadosSolicitarNoValido() {
    return this.form.get('documentosEstadosSolicitar').invalid && this.form.get('documentosEstadosSolicitar').touched;
  }

  get cursoModuloNoValido() {
    return this.form.get('cursoModulo').invalid && this.form.get('cursoModulo').touched;
  }

  get vigenciaNoValida() {
    return this.form.get('vigenciaDesde').invalid && this.form.get('vigenciaDesde').touched;
  }

  get vigenciaNoValidaHasta() {
    return this.form.get('vigenciaHasta').invalid && this.form.get('vigenciaHasta').touched;
  }

  get descripcionNoValida() {
    return this.form.get('descripcion').invalid && this.form.get('descripcion').touched;
  }

  get detalleNoValido() {
    return this.form.get('detalle').invalid && this.form.get('detalle').touched;
  }

  async getTipoPuestos() {
    this.tipoPuestos = await this.catalogoService.findDescendantsByKey('TIPO_PUESTO');
  }

  async getModalidades() {
    this.modalidades = await this.catalogoService.findDescendantsByKey('MODALIDAD');
  }

  async getAreas() {
    this.areas = await this.catalogoService.findDescendantsByKey('AREA');
  }

  async getCircuitos() {
    this.circuitos.push({ circuito: "1", viewValue: 'Pago Inicial - Segundo Pago' });
    this.circuitos.push({ circuito: "2", viewValue: 'Sin pago Inicial - Únicamente un Pago post Pre-Aprobacion' });
  }

  createForm() {
    this.form = this.fb.group({
      nombre: new FormControl(this.actividad.nombre, [Validators.required]),
      descripcion: new FormControl(this.actividad.descripcion, [Validators.required]),
      pais: new FormControl(this.actividad.paisDisponible._id),
      // adjuntos: new FormControl(''),
      cursoModulo: new FormControl(this.actividad.cursos,),
      documentos: new FormControl(this.actividad.documentos),
      vigenciaDesde: new FormControl(this.actividad.vigenciaDesde, [Validators.required]),
      vigenciaHasta: new FormControl(this.actividad.vigenciaHasta, [Validators.required]),
      vigente: new FormControl(this.actividad.vigente),
      documentosEstadosSolicitar: new FormControl(''),
      requisitos: new FormControl(this.actividad.requisitos,),
      importante: new FormControl(this.actividad.importante,),
      finalizando: new FormControl(this.actividad.finalizando,),
      imagen: new FormControl('',),
      detalle: new FormControl(this.actividad.detalle),
      documentacionRequerida: new FormControl(this.actividad.documentacionRequerida,),
      tipoPuesto: new FormControl(''),
      area: new FormControl(''),
      resumenAvatar: new FormControl(this.actividad.resumenAvatar),
      modalidad: new FormControl(''),
      sueldo: new FormControl(''),
      costoAdministrativo: new FormControl(this.actividad.costoAdministrativo,),
      costoPostAprobacion: new FormControl(this.actividad.costoPostAprobacion,),
      circuito: new FormControl(2),

      //especifico beneficios
      antiguedadMinima: new FormControl(this.actividad.antiguedadMinima, [ Validators.required, Validators.min(0)]),
      plazoSolicitud: new FormControl(this.actividad.plazoSolicitud, [ Validators.required, Validators.min(0)]),
      // frecuencia: new FormControl('', ),
      
      actividadTipo: new FormControl('679bd689a9a18a04209c41a0'),
      frecuencia: this.fb.group({
        valor: [''],
        descripcion: ['']
      }, [ Validators.required]),
      entidades: this.fb.array([]),
    }, {
      validators: this.validadores.fechaFinMenor('vigenciaDesde', 'vigenciaHasta')
    });
  }

  getActividad() {
    return this.actividad = this.actividadesService.getActividadSeleccionada();
  }

  async getEstadoVariables() {
    if (this.getActividad() === undefined) {
      this.router.navigateByUrl('/');
      return;
    } else {
      this.getActividad();
      this.flagLoaded = true;
    }
  }

  async getAdjuntosAll() {
    this.adjuntos = await this.actividadesService.getAdjuntos();
  }

  async getCursosModulo() {
    this.cursosModulos = await this.cursosService.getCursosModulos();
  }

  async getPaisesDisponibles() {
    this.paisesDisponibles = await this.paisesService.getPaisesDisponibles();
  }

  async put() {

    // await this.guiMsjService.msjFormSubmit('Guardando');
    this.flagProcesando = true;
    this.actividadesService.put(this.actividad._id, await this.setDataForma()).then(async (actividad: Actividad) => {
      if (this.selectedFile !== undefined) {
        await this.uploadFile(this.selectedFile, actividad._id);
      }
      // await this.guiMsjService.msjFormSubmit('DatosGuardados');
      this.flagProcesando = false;
      this.router.navigateByUrl('/listado-noticia');
      return;
    });
  }

  msjError() {
    Swal.close();
    Swal.fire({
      icon: 'error',
      title: 'Error al guardar!',
      showConfirmButton: false,
      timer: 1100
    });
  }

//   async asignarDocumentosEstadosSolicitar(documentosSolicitar: string[]): Promise<DocumentosEstadosSolicitar[]> {
//     documentosSolicitar.forEach((documentoSolicitar: any) => {
//       if (documentoSolicitar.hasOwnProperty('documento')) {
//         const documento = this.adjuntos.find(element => element._id == documentoSolicitar.documento._id);
//         this.documentosEstadosSolicitar.push({ documento: documento, entregado: false, solicitar: true, obligatorio: false });
//       } else {
//         const documento = this.adjuntos.find(element => element._id == documentoSolicitar);
//         this.documentosEstadosSolicitar.push({ documento: documento, entregado: false, solicitar: true, obligatorio: false });
//       }

//     });
//     return this.documentosEstadosSolicitar;
//   }

  async setDataForma(): Promise<Actividad> {

    const entidadSeleccionada = (this.form.get('entidades') as FormArray).controls.map(control => ({
      valor: control.get('valor')?.value,
      descripcion: control.get('descripcion')?.value
    }));

    const data: Actividad = {

      i18n: 'es',
      nombre: this.form.value.nombre,
      descripcion: this.form.value.descripcion,
      paisDisponible: this.form.value.pais,
      // adjuntos: this.form.value.adjuntos,
      cursos: this.form.value.cursoModulo,
      vigenciaDesde: this.form.value.vigenciaDesde,
      vigenciaHasta: this.form.value.vigenciaHasta,
      vigente: this.form.value.vigente,
      detalle: this.form.value.detalle,
      requisitos: this.form.value.requisitos,
      importante: this.form.value.importante,
      finalizando: this.form.value.finalizando,
      documentacionRequerida: this.form.value.documentacionRequerida,
      // sueldo: this.form.value.sueldo,
      // tipoPuesto: this.form.value.tipoPuesto,
      // modalidad: this.form.value.modalidad,
      // area: this.form.value.area,
      resumenAvatar: this.form.value.resumenAvatar,
      costoAdministrativo: this.form.value.costoAdministrativo,
      costoPostAprobacion: this.form.value.costoPostAprobacion,
      circuito: +this.form.value.circuito,
      documentosEstadosSolicitar: null,

      //especifico Beneficios
      antiguedadMinima: this.form.value.antiguedadMinima,
      plazoSolicitud: this.form.value.plazoSolicitud,
      frecuencia: {
        valor: this.form.get('frecuencia.valor')?.value,
        descripcion: this.form.get('frecuencia.descripcion')?.value
      },
      entidades: entidadSeleccionada,
      actividadTipo: this.form.value.actividadTipo,
    };

    return data;

  }

  /* UPLOAD */

  /* subo archivo con observable*/
  subscribeAvanceUpload() {
    this.subscriptionAvance = this.mediaService.getAvance().subscribe(resp => {
      if (resp) {
        this.value = resp.value;
      } else {
        this.value = 0;
      }
    });
  }

  openFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
  }

  onChangeFile(file: File, event) {
    if (file) {
      this.openFileSelected(event);
      this.fileName = file.name;
      this.file = file;

      readImagePreview(file,
        value => {
          this.imageUrl = value;
          this.esHeic = false;
        },
        () => {
          this.esHeic = true;
          this.imageUrl = null;
        }
      );
    }
  }

  async uploadFile(selectedFile, idactividad) {
    this.cargandoArchivo = true;
    await this.mediaService.uploadImgActividad2(selectedFile, idactividad).then(resp => {
      if (resp) {
        if (this.value === 100) { this.cargandoArchivo = false; }
      } else {
        this.guiMsjService.msjFormSubmit('uploadDocumentERROR');
      }
    });
  }
  /* FIN UPLOAD */

  // Especifico Beneficios

  onFrecuenciaChange(seleccion: { valor: string; descripcion: string }) {
    this.form.get('frecuencia')?.patchValue({
      valor: seleccion.valor,
      descripcion: seleccion.descripcion
    });
  }

  onEntidadChange(event: MatSelectChange): void {
    const entidadArray = this.form.get('entidades') as FormArray;

    // Actualizamos directamente el FormArray con los valores seleccionados
    entidadArray.clear();
    event.value.forEach((entidad: any) => 
        entidadArray.push(this.fb.group(entidad))
    );

    // Sincronizamos selectedEntidades con el valor actualizado
    this.selectedEntidades = entidadArray.value;
  }

  validarIngresoSoloNumeros(event: KeyboardEvent): void {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      return;
    }
    if (event.key === '-') {
      event.preventDefault();
      return;
    }
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  obtenerTipoActividades(): void {
    this.tipoActividadService.obtenerTipoActividades().subscribe({
      next: (data) => {
        this.tipoActividades = data.map(item => ({
          idTipoActividad: item._id,
          denominacionTipoActividad: item.denominacion
        }));
  
        // Buscar el tipo de actividad "Noticias" por su ID
        const noticiasTipoActividad = this.tipoActividades.find(
          item => item.idTipoActividad === '6797e70da55cde1d9453be05'
        );
  
        // Si se encuentra, establecerlo como seleccionado
        if (noticiasTipoActividad) {
          this.selectedIdTipoActividad = noticiasTipoActividad.idTipoActividad;
          this.form.get('actividadTipo')?.setValue(this.selectedIdTipoActividad);
          console.log('Tipo de actividad "Noticias" seleccionado automáticamente:', this.selectedIdTipoActividad);
        }
      },
      error: (err) => console.error('Error al recuperar datos:', err)
    });
  }

  onSelectTipoActividad(event: any): void {
    this.selectedIdTipoActividad = event.value; // El valor es el idTipoActividad seleccionado
  
    // Actualizamos el valor del campo 'actividadTipo' en el formulario
    this.form.get('actividadTipo')?.setValue(this.selectedIdTipoActividad);
  
    console.log('ID seleccionado:', this.selectedIdTipoActividad);
  }

}
